document.addEventListener('DOMContentLoaded', () => {
    const updateCartBundle = async () => {
        try {
            const cartResponse = await fetch('/cart.js', {
                method: 'GET',
                credentials: 'same-origin',
            });
            if (cartResponse.ok) {
                const updatedCart = await cartResponse.json();
                const cartBubble = document.querySelector('.cart-count-bubble');
                if (cartBubble) {
                cartBubble.textContent = updatedCart.item_count;
                }

                const notificationCount = document.getElementById('cart-notification-button');
                const notificationSubtotal = document.getElementById('cart-notification-subtotal');

                if (notificationCount) {
                    notificationCount.textContent = updatedCart.item_count > 1 ? `${updatedCart.item_count} items` : `${updatedCart.item_count} item`;
                }

                if (notificationSubtotal) {
                    notificationSubtotal.textContent = `$${(updatedCart.items_subtotal_price / 100).toFixed(2)}`;
                }

            }
        } catch (error) {
            console.error('Error updating cart bundle:', error);
        }
    };

    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification) {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class') {
                    const notification = mutation.target;
                    if (notification.classList.contains('active')) {
                        updateCartBundle();
                    }
                }
            });
        });

        observer.observe(cartNotification.notification, { attributes: true });
    }

    document.addEventListener('click', async (event) => {
        const button = event.target.closest('.home-add-to-cart');
        if (!button) return;

        const container = button.closest('.custom-most-loved__info-container');
        if (!container) return;

        const tallaSelect = container.querySelector('.talla-select');
        if (!tallaSelect) {
            console.error('could not find tallaSelect');
            return;
        }
        const variantId = tallaSelect.value;
        if (!variantId) {
            console.error('could not find variantId');
            return;
        }

        const productTitle = button.getAttribute('data-product-title') || '';
        const productPrice = button.getAttribute('data-product-price') || '';
        const productImage = button.getAttribute('data-product-image') || '';
        const productVariant = button.getAttribute('data-product-variant') || '';
        const productImageAlt = button.getAttribute('data-product-image-alt') || '';

        const selectedSize = tallaSelect.options[tallaSelect.selectedIndex].text;

        try {
            const params = new URLSearchParams();
            params.append('id', variantId);
            params.append('quantity', 1);

            const addResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                credentials: 'same-origin',
                body: params.toString(),
            });

            if (addResponse.ok) {
                const newCardHTML = `
          <div class="cart-notification-product">
            ${productImage
                        ? `
                  <div class="cart-notification-product__image-2 global-media-settings">
                    <img src="${productImage}" alt="${productImageAlt}" class="img-product" width="100%" height="100%" loading="lazy">
                  </div>
                `
                        : ''
                    }
            <div class="cart-notification-product-details">
                    <h3 class="cart-notification-product__name h4">
                        ${productTitle}
                      </h3>
                      <dl>
                        <div class="cart-notifitacion__option-container">
                          <div class="product-option">
                            Color: ${productVariant}
                          </div>
                          <div class="product-option">
                            Size: ${selectedSize}
                          </div>
                          <div class="product-option-price">
                            ${productPrice}
                          </div>
                        </div>
                      </dl>
            </div>
          </div>
        `;

                const notificationProductDiv = document.getElementById('cart-notification-product-2');
                if (notificationProductDiv) {
                    notificationProductDiv.innerHTML += newCardHTML;
                }

                updateCartBundle();
            } else {
                console.error('Error adding product to cart:', addResponse.status);
            }

        } catch (error) {
            console.error('Failled to add product to cart:', error);
        }
    })
})
